module.exports = __webpack_public_path__ + "static/media/flow_3.072d09dd.gif";